import React from 'react'
import { Badge, Button, Typography } from '@mui/material'
import { string, object, number } from 'prop-types'

const FilterButton = ({ text = '', Icon, color, activeCount = 0, ...rest }) => {
  return (
    <Button color={color} sx={{ width: 'max-content' }} {...rest}>
      <Badge
        badgeContent={activeCount}
        color="error"
        invisible={activeCount === 0}
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {Icon && <Icon width={24} height={24} style={{ fill: color }} />}
      </Badge>
      <Typography variant="p" sx={{ ml: 0.5 }}>
        {text}
      </Typography>
    </Button>
  )
}

FilterButton.propTypes = {
  text: string,
  bg: string,
  Icon: object,
  color: string,
  activeCount: number
}

export default FilterButton
